package linkerpangoquipdb

import kotlin.Long
import kotlin.String

public data class Vehicle_model(
  public val id: Long,
  public val brand_id: Long,
  public val name: String,
  public val updated_at: Long,
)
